module.exports = __webpack_public_path__ + "img/resources-375.98c05c1a.jpg";